/**
 * Created by arieh on 12/6/2017.
 */


const SCHEME = {
    IS_DEEP_LINK: 'deep_link_execute',
    DL_DEL1:'?deeplink=',
    DL_DEL2:'#deeplink=',
    DEEP_LINK_FEATUR_NAME: 'deeplinkfeature'
};


export {SCHEME};